import { render, staticRenderFns } from "./FeatureModal.vue?vue&type=template&id=15200fb1&"
import script from "./FeatureModal.vue?vue&type=script&lang=js&"
export * from "./FeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./FeatureModal.vue?vue&type=style&index=0&id=15200fb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports